import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import ReactSelect from 'react-select'
import { useToasts } from 'react-toast-notifications'
import widgetsApi from 'services/api/widgets'

import styles from './ExcludedPagesDialog.module.scss'

const ExcludedPagesDialog = ({ onClose, siteMap }) => {
  const [isLoading, setIsLoading] = useState(false)

  const [widgets, setWidgets] = useState(null)
  const { addToast } = useToasts()

  useEffect(() => {
    setIsLoading(true)

    widgetsApi.list
      .get()
      .then(response => {
        setWidgets(response.map(w => ({ ...w, data: JSON.parse(w.data) })))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  function setPagesToHide(pagesToHide) {
    setWidgets(widgets.map(w => ({ ...w, data: { ...w.data, pagesToHide } })))
  }

  const pagesToHide = widgets?.[0]?.data?.pagesToHide || []

  function saveChanges() {
    setIsLoading(true)
    widgetsApi.list
      .post({ data: widgets.map(w => ({ ...w, data: JSON.stringify(w.data) })) })
      .then(() => {
        onClose()
        addToast('Excluded pages are updated', { appearance: 'success' })
      })
      .catch(err => {
        addToast(`${err}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  if (isLoading) {
    return (
      <Dialog>
        <LoadingIndicator white />
      </Dialog>
    )
  }

  return (
    <ConfirmationDialog
      title="Excluded pages"
      onClose={onClose}
      onConfirm={saveChanges}
      positiveMessage="Save changes"
      negativeMessage="Cancel"
      allowOverflow
      theme="blacklist"
      maxWidth={600}
    >
      <div className={styles.pagesToHideContainer}>
        <p className={styles.label}>Pages to hide the widgets</p>
        <ReactSelect
          options={siteMap.map(page => ({
            value: page,
            label: page
          }))}
          isMulti
          placeholder="Type page name..."
          value={pagesToHide}
          onChange={pagesToHide => setPagesToHide(pagesToHide)}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default ExcludedPagesDialog
